import { Routes } from "@angular/router";
import { AuthGuard } from "src/app/core/guards/auth.guard";

export const AffiliatesRoutes: Routes = [
  {
    path: "affiliates",
    loadComponent: () =>
      import("./affiliates/affiliates.component").then(
        (m) => m.AffiliatesComponent,
      ),
    canActivate: [AuthGuard],
    children: [
      {
        path: "",
        loadComponent: () =>
          import("./affiliate-list/affiliate-list.component").then(
            (m) => m.AffiliateListComponent,
          ),
      },
      {
        path: "add",
        loadComponent: () =>
          import("./affiliates-form/affiliates-form.component").then(
            (m) => m.AffiliatesFormComponent,
          ),
      },
      {
        path: "view/:id",
        loadComponent: () =>
          import("./affiliates-form/affiliates-form.component").then(
            (m) => m.AffiliatesFormComponent,
          ),
      },
    ],
  },
];
